import axios, { AxiosError, AxiosResponse } from 'axios'
import { MCity, RegroundTypes } from '@Models/auth.model'
import { ICommonQuery } from '@Models/common.model'
import * as Redux from 'redux'
import { CommonService } from '@Services/common.service'
import { ToastServices } from '@Services/toast.service'
import SharedActions from '@SharedActions/loading.action'
import { APIServices } from '@Services/api.service'
import * as _ from 'lodash'
import { EducatorActionTypes } from '../educator.action-types'

const REGROUND = '/admin/reground?type=CITY'

const getEducatorInfo = (queryParams?: any) => {
    return (dispatch: Redux.Dispatch, getState: any) => {
        const params = getState()?.educator?.educatorInfo?.eudcatorQueries

        dispatch(SharedActions.setPageLoading(true) as any)
        const url = `${APIServices.apiUrlV1}/admin/associations`
        // APIServices.axiosConfig()
        // const params = {
        //     limit: 100,
        //     ...queryParams,
        // }
        const token = getState()?.auth?.publicToken

        axios
            .get(`${url}`, { params: { token, ...params } })
            // .get(`${url}`, { params })
            .then((res) => {
                dispatch(SharedActions.setPageLoading(false) as any)
                const { data, metadata } = res.data
                dispatch({
                    type: EducatorActionTypes.GET_EDUCATOR_INFO,
                    payload: data,
                })
                dispatch({
                    type: EducatorActionTypes.GET_EDUCATOR_INFO_METADATA,
                    payload: metadata,
                })
            })
            .catch((errors) => {
                dispatch(SharedActions.setClientLoading(false) as any)
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const setEducatorQueries = (payload?: ICommonQuery) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch({
            type: EducatorActionTypes.SET_EDUCATOR_QUERIES,
            payload,
        })
    }
}

const getEducatorDetail = (id: string) => {
    return (dispatch: Redux.Dispatch, getState: any) => {
        dispatch({
            type: EducatorActionTypes.SET_EDUCATOR_LOADING_MODAL,
            payload: true,
        })
        const url = `${APIServices.apiUrlV1}/admin/associations/${id}`
        // APIServices.axiosConfig()
        const params = { token: getState()?.auth?.publicToken }
        axios
            .get(`${url}`, { params })
            .then((res) => {
                dispatch({
                    type: EducatorActionTypes.SET_EDUCATOR_LOADING_MODAL,
                    payload: false,
                })
                dispatch({
                    type: EducatorActionTypes.GET_EDUCATOR_INFO_DETAIL,
                    payload: res.data,
                })
            })
            .catch((errors) => {
                dispatch({
                    type: EducatorActionTypes.SET_EDUCATOR_LOADING_MODAL,
                    payload: false,
                })
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const createEducatorInfo = (payload: any) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(SharedActions.setPageLoading(true) as any)
        APIServices.axiosConfig()
        return new Promise((resolve, reject) => {
            const url = `${APIServices.apiUrlV1}/admin/associations`

            axios
                .post(url, payload)
                .then((response) => {
                    dispatch(SharedActions.setPageLoading(false) as any)
                    const title =
                        payload?.type === 'MEDICAL' ? 'Medical' : 'Educator'
                    ToastServices.success(`${title} Created`)
                    resolve(response)
                })
                .catch((errors) => {
                    dispatch(SharedActions.setPageLoading(false) as any)
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const updateEducatorInfo = (id: string, payload: any) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(SharedActions.setPageLoading(true) as any)
        APIServices.axiosConfig()
        return new Promise((resolve, reject) => {
            const url = `${APIServices.apiUrlV1}/admin/associations/${id}`

            axios
                .put(url, payload)
                .then((response) => {
                    dispatch(SharedActions.setPageLoading(false) as any)
                    const title =
                        payload?.type === 'MEDICAL' ? 'Medical' : 'Educator'
                    ToastServices.success(`${title} Updated`)
                    resolve(response)
                })
                .catch((errors) => {
                    dispatch(SharedActions.setPageLoading(false) as any)
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const clearDynamicCities = (index: number, deleted?: boolean) => {
    return (dispatch: Redux.Dispatch, getState: any) => {
        const existingData = getState()?.educator?.educatorInfo?.dynamicCities
        const tempCities = _.cloneDeep(existingData) || []
        if (deleted) {
            tempCities?.splice(index, 1)
        } else {
            tempCities[index] = []
        }
        dispatch({
            type: EducatorActionTypes.GET_DYNAMIC_CITY,
            payload: tempCities,
        })
    }
}

const getDynamicCity = (index: any, params?: ICommonQuery) => {
    return (dispatch: Redux.Dispatch, getState: any) => {
        const cities = getState()?.educator?.educatorInfo?.dynamicCities

        APIServices.axiosConfig()
        axios
            .get(REGROUND, { params: { limit: 0, ...params } })
            .then((response: AxiosResponse) => {
                const payload = []
                const { data } = response?.data
                const formatted = data?.map((item: MCity) => new MCity(item))
                if (cities?.length) {
                    cities[index] = formatted
                } else {
                    cities.push(formatted)
                }
                dispatch({
                    type: EducatorActionTypes.GET_DYNAMIC_CITY,
                    payload: cities,
                })
            })
            .catch((errors: AxiosError) => {
                console.log(errors)
            })
    }
}

const EducatorInfoActions = {
    getEducatorInfo,
    getEducatorDetail,
    createEducatorInfo,
    updateEducatorInfo,
    getDynamicCity,
    setEducatorQueries,
    clearDynamicCities,
}

export default EducatorInfoActions
